import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { competitorData } from '../data/mock';

export default function ComparisonTable() {
  return (
    <section id="comparison" className="py-20 sm:py-28 bg-indigo-50/40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            Industry Pricing Comparison
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            See how Shipmaster stacks up against traditional 3PLs. All pricing based on 2025 industry research and publicly available benchmarks.
          </p>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Provider</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Pick Fee (1st Item)</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Additional Items</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Storage Model</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Receiving</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Freight Management</th>
                  <th className="px-5 py-4 text-sm font-bold text-slate-700">Monthly Minimum</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {competitorData.map((row) => (
                  <tr
                    key={row.provider}
                    className={
                      row.highlighted
                        ? 'bg-indigo-50/70 border-l-4 border-l-indigo-600'
                        : 'hover:bg-slate-50/50 transition-colors'
                    }
                  >
                    <td className="px-5 py-4">
                      <p className={`font-bold ${row.highlighted ? 'text-indigo-700' : 'text-slate-900'}`}>
                        {row.provider}
                      </p>
                      {row.label && (
                        <p className="text-xs font-bold text-indigo-600 mt-0.5">{row.label}</p>
                      )}
                    </td>
                    <td className="px-5 py-4 text-sm text-slate-700">{row.pickFee}</td>
                    <td className="px-5 py-4 text-sm text-slate-700">{row.additionalItems}</td>
                    <td className="px-5 py-4 text-sm text-slate-700">
                      <p>{row.storageModel}</p>
                      {row.storageNote && (
                        <p className="text-xs text-indigo-600 mt-0.5">{row.storageNote}</p>
                      )}
                    </td>
                    <td className="px-5 py-4 text-sm text-slate-700">{row.receiving}</td>
                    <td className="px-5 py-4 text-sm text-slate-700">{row.freight}</td>
                    <td className="px-5 py-4 text-sm text-slate-700">{row.minimum}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mt-5 text-sm text-slate-600 text-center max-w-3xl mx-auto">
          Competitor pricing is based on 2025 industry research and publicly available benchmarks. Actual pricing may vary by volume, region, and contract terms.{' '}
          <span className="font-bold text-slate-900">
            Shipmaster pricing is transparent, usage-based, and guaranteed.
          </span>
        </p>

        <div className="mt-8 text-center">
          <Link
            to="/compare"
            className="inline-flex items-center gap-2 text-sm font-bold text-indigo-700 hover:text-indigo-800 transition-colors"
            data-testid="comparison-section-deep-link"
          >
            Want a head-to-head against your current 3PL? See detailed comparisons
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
